import axios from '../lib/axios';

import { API_URL } from '../config';
import * as types from '../constants/ActionTypes';

export function fetchTicker() {
    const url = `${API_URL}/ticker`;

    return {
        types: [types.GET_TICKER, types.GET_TICKER_SUCCESS, types.GET_TICKER_FAILURE],
        promise: axios.get(url, {
            withCredentials: true
        })
    };
}
